export class SalesTypeFord {

    id: number;
    description: string;

    constructor() {
	}
}